function mountTagOption(tag) {
	return {
		id: tag._id,
		value: tag.name,
		label: tag.name,
	}
}

export default mountTagOption
